import React from 'react'
import { useFormContext } from 'react-hook-form'

import NumberField from 'components/layout/form/fields/NumberField'
import PictureField from 'components/layout/form/fields/PictureField'
import RadiosField from 'components/layout/form/fields/RadiosField'
import TextareaField from 'components/layout/form/fields/TextareaField'
import TextField from 'components/layout/form/fields/TextField'


const Portal = () => {
  const { readOnly } = useFormContext()

  return (
    <>
      <TextField
        label="Etiquette : "
        name="label"
        placeholder="Ex. : P1"
      />
      <NumberField
        label="Largeur : "
        name="portalWidth"
        placeholder="Ex. : 0,2"
        unitLabel='m'
      />
      <RadiosField
        isBoolean
        label="Batardeau existant "
        name="hasBatardeau"
      />
      <NumberField
        label="Hauteur du batardeau : "
        name="batardeauHeight"
        placeholder="Ex. : 0,5"
        unitLabel='m'
      />
      <TextareaField
        label="Commentaire sur le batardeau existant (efficacité, type de batardeau) : "
        name="batardeauComment"
      />
      <PictureField
        folderPath="photos"
        label={`Photo${readOnly ? '' : ' (facultatif)'} :`}
        name="photo"
      />
      <TextareaField
        label="Commentaire ouvrant : "
        name="comment"
      />
    </>
  )
}

export default Portal
